import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMegaphone = props => /*#__PURE__*/_jsxs("svg", {
  viewBox: "0 0 56 56",
  width: "1em",
  height: "1em",
  ...props,
  children: [/*#__PURE__*/_jsx("path", {
    fill: "#2F4859",
    d: "M14.031 21.885c-.166 0-.3.196-.3.437v4.56c0 .242.134.438.3.438h1.059v-5.436H14.03z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#64798A",
    d: "M39.551 21.885v6.794c2.252 0 4.077-1.52 4.077-3.397 0-1.876-1.825-3.397-4.077-3.397z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#D15241",
    d: "M38.192 12.372h1.359v25.82h-1.359z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#EBF0F3",
    d: "M36.833 12.372v25.82s-4.452-6.49-12.23-8.353v-9.114c7.778-1.863 12.23-8.353 12.23-8.353z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#3A556A",
    d: "M23.865 20.526h-9.397c-.407 0-.737.314-.737.702v8.108c0 .388.33.703.737.703h9.397c.407 0 .738-.315.738-.703v-8.108c0-.388-.33-.702-.738-.702z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#D15241",
    d: "M24.72 41.037l-2.014-9.64h-6.257l1.946 11.752c.039.275.266.48.534.48H24.72v-.001c.686-.004 1.242-.582 1.242-1.296 0-.713-.556-1.29-1.242-1.295z"
  }), /*#__PURE__*/_jsx("g", {
    fill: "#64798A",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16.527 23.248h8.008v.946h-8.008zM16.527 25.57h8.008v.946h-8.008zM16.527 27.89h8.008v.945h-8.008z"
    })
  })]
});
export default SvgMegaphone;